export const VERSION = {
  PROD: 'V. 3.3.2',
  QA: 'V. 5.17.0 (QA)',
}
